// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"504":"chunk-vendors","996":"chunk-common","8129":"program"}[chunkId] + "." + {"504":"94c93221","996":"fc5d8b94","8129":"4a355e11"}[chunkId] + ".css";
};